export default __webpack_public_path__ + "static/media/safepay-white.fa1539ef.svg";